import bus from '~/bus'
import {useEventHelper} from '~/helpers/eventHelper'

export default {
  name: 'shared',
  do: function (payload) {
    console.log('DEBUG shared: ', this, payload)
    const {getEventFile} = useEventHelper()
    if (this.file === payload.file_id || (this.file !== payload.parent_id && this.fileAncestors && this.fileAncestors.includes(payload.file_id))) {
      getEventFile(payload.deprecated_file_id).then((response) => {
        bus.$emit('refreshAppbar', response)
        bus.$emit('refreshRightDrawer', response)
      })
      bus.$emit('refreshRightDrawerSharers')
      bus.$emit('doBackgroundReload', 'shared 1')
    } else if (
      (this.file === 'recent' && payload.recent) ||
      this.file === payload.parent_id || (this.file === 'myspace' && payload.parent_id === '')) {
      getEventFile(payload.deprecated_file_id).then((response) => {
        if (this.fileChildren && this.fileChildren.includes(payload.file_id)) {
          bus.$emit('updateFile', response)
          bus.$emit('refreshRightDrawer', response)
          bus.$emit('refreshRightDrawerSharers', response)
        } else {
          bus.$emit('insertFile', response)
          this.fileChildren.push(payload.file_id)
        }
      })
    } else if (this.file === payload.sharer ||
      (this.file === 'shared' &&
        (!this.fileChildren ||
         (this.fileChildren && (!this.fileChildren.includes(payload.sharer)))
        )
      )) {
      bus.$emit('doBackgroundReload', 'shared 2')
    }
    if ((this.fileChildren && this.fileChildren.includes(payload.parent_id))) {
      getEventFile(payload.deprecated_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/shared.js